import React, { useEffect, useState } from "react";
import t from "../../../helpers/t";
import { Biscuit, Notification, getAllUrlParams } from "../../../../utils";
import moment from "moment";
import { $ } from "../../../../../vendor";
import { voucherTypesActions, contingentsActions, useSelector } from "inbooma-api";
import { getContentModifications } from "../../../../App";
import InboomaSubmenu from "../../../components/InboomaSubmenu";
import SortNav from "../../../components/SortNav";
import VouchersList from "./VouchersList";
import VoucherLoginsList from "./VoucherLoginsList";
import ItemView from "./ItemView";
import { isViewVisible } from "../../../../utils/ViewSettings";
import VoucherSidebar from "./VoucherSidebar";
import { in_array } from "../../../../utils/Helper";
import ItemLoginView from "./ItemLoginView";

const VouchersView = (props) => {
  const { params, dispatch, returnPath, addd } = props;
  const currentUrl = new URL(window.location.href);
  const searchParams = currentUrl.searchParams;
  const allUrlParams = getAllUrlParams(window.location.href);
  const allUrlParamsClone = { ...allUrlParams };
  allUrlParams?.q !== undefined && delete allUrlParams.q;
  let type = allUrlParams?.type !== undefined ? allUrlParams?.type : "discount";
  allUrlParams.type = type;
  let language = Biscuit.get("user.lang").replace("-", "_");
  const [initialized, setInitialized] = useState(false);
  const [filter, setFilter] = useState({
    ...allUrlParams,
  });
  const [sort, setSort] = useState({
    sort: "name",
    direction: "asc",
  });
  const paginationLimit = 40;
  const [pagination, setPagination] = useState({
    has_next_page: false,
    current_page: 1,
  });

  const _vouchers = useSelector((state) => state.voucher_types_data.getVoucherTypes);
  const _voucherLogins = useSelector((state) => state.voucher_types_data.getVoucherLogins);
  const [vouchersPending, setVouchersPending] = useState(false);
  const [vouchers, setVouchers] = useState([]);
  const [voucherLogins, setVoucherLogins] = useState([]);
  const [index, setIndex] = useState(null);

  const _contingents = useSelector((state) => state.contingents_data.getContingents);
  const [contingentsPending, setContingentsPending] = useState(false);

  const _voucher = useSelector((state) => state.voucher_types_data.getVoucherType);
  const _deleteVoucher = useSelector((state) => state.voucher_types_data.deleteVoucherType);
  const [voucherPending, setVoucherPending] = useState(false);
  const [voucher, setVoucher] = useState([]);

  const _voucherLogin = useSelector((state) => state.voucher_types_data.getVoucherLogin);
  const _deleteVoucherLogin = useSelector((state) => state.voucher_types_data.deleteVoucherLogin);
  const [voucherLoginPending, setVoucherLoginPending] = useState(false);
  const [voucherLogin, setVoucherLogin] = useState([]);

  const [resetFilter, setResetFilter] = useState(false);

  const [add, setAdd] = useState(addd);
  const _queryState = {
    timeStamp: 0,
    value: "",
  };

  useEffect(() => {
    if (initialized || vouchersPending || voucherPending || contingentsPending) return;
    let requestFilter = { ...filter };
    requestFilter = { ...requestFilter, page: 1 };
    requestFilter = { ...requestFilter, limit: paginationLimit };
    requestFilter = { ...requestFilter, sort: sort.sort };
    requestFilter = { ...requestFilter, direction: sort.direction };
    requestFilter = { ...requestFilter, ...allUrlParams };

    if (params !== null && typeof params[1] !== "undefined" && params[0] === "id") {
      requestFilter = { ...requestFilter, id: params[1] };
    }
    if (allUrlParamsClone?.q !== undefined) {
      requestFilter = { ...filter, q: allUrlParamsClone?.q };
    }
    if (in_array(type, ["discount", "gift_card"])) {
      dispatch(
        voucherTypesActions.getVoucherTypes({
          token: Biscuit.get("token"),
          suffix: "",
          filter: requestFilter,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        })
      );
      setVouchersPending(true);
    }
    if (in_array(type, ["vlogin"])) {
      dispatch(
        voucherTypesActions.getVoucherLogins({
          token: Biscuit.get("token"),
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        })
      );
      setVouchersPending(true);
    }
    if (params !== null && !isNaN(params[0])) {
      if (in_array(type, ["discount", "gift_card"])) {
        dispatch(
          voucherTypesActions.getVoucherType({
            token: Biscuit.get("token"),
            id: params[0],
            parameters: {
              headers: {
                "Accept-Language": language,
                "Content-Language": language,
              },
            },
          })
        );
        setVoucherPending(true);
      }
      if (in_array(type, ["vlogin"])) {
        dispatch(
          voucherTypesActions.getVoucherLogin({
            token: Biscuit.get("token"),
            id: params[0],
            parameters: {
              headers: {
                "Accept-Language": language,
                "Content-Language": language,
              },
            },
          })
        );
        setVoucherLoginPending(true);
      }
    }
    dispatch(
      contingentsActions.getContingents({
        token: Biscuit.get("token"),
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      })
    );
    setContingentsPending(true);
  }, []);

  useEffect(() => {
    if (_deleteVoucher.success === "" || !voucherPending) {
      return;
    }
    if (_deleteVoucher.success === true) {
      dispatch(voucherTypesActions.getVoucherTypesResetData());
      let currentURL = currentUrl.search;
      let returnUrl = `/vouchers${currentURL}`;
      window.location.replace(returnUrl);
    } else {
      showNotification(
        "warning",
        null,
        "Gutschein konnte nicht gelöscht werden. API Message: " + _deleteVoucher.data.message
      );
    }
    setVouchersPending(false);
  }, [_deleteVoucher]);

  useEffect(() => {
    if (_deleteVoucherLogin.success === "" || !voucherLoginPending) {
      return;
    }
    if (_deleteVoucherLogin.success === true) {
      dispatch(voucherTypesActions.getVoucherLoginsResetData());
      let currentURL = currentUrl.search;
      let returnUrl = `/vouchers${currentURL}`;
      window.location.replace(returnUrl);
    } else {
      showNotification(
        "warning",
        null,
        "Gutschein konnte nicht gelöscht werden. API Message: " + _deleteVoucher.data.message
      );
    }
    setVoucherLoginPending(false);
  }, [_deleteVoucherLogin]);

  useEffect(() => {
    if (!contingentsPending || _contingents.success === "") {
      return;
    }
    setContingentsPending(false);
    if (!voucherPending && !vouchersPending) {
      setInitialized(true);
    }
  }, [_contingents]);

  useEffect(() => {
    if (voucherPending === false || _voucher.success === "") {
      return;
    }
    if (_voucher.success === true) {
      setVoucher(_voucher.data);
      //setIndex(_resource.data.id);
    } else {
      console.log("Failed fetching resource!");
    }
    setVoucherPending(false);

    if (!vouchersPending && !contingentsPending) {
      setInitialized(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_voucher]);

  useEffect(() => {
    if (vouchersPending === false || _vouchers.success === "") {
      return;
    }

    if (_vouchers.success === true) {
      setVouchers(_vouchers.data);
      setPagination({ ..._vouchers.pagination });
    } else {
      console.log("Failed fetching vouchers!");
    }
    setVouchersPending(false);
    if (!voucherPending && !contingentsPending) {
      setInitialized(true);
    }
    $(window).scrollTop(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_vouchers]);

  useEffect(() => {
    if (voucherLoginPending === false || _voucherLogin.success === "") {
      return;
    }
    if (_voucherLogin.success === true) {
      setVoucherLogin(_voucherLogin.data);
      //setIndex(_resource.data.id);
    } else {
      console.log("Failed fetching voucherLogin!");
    }
    setVoucherLoginPending(false);

    if (!vouchersPending && !contingentsPending) {
      setInitialized(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_voucherLogin]);

  useEffect(() => {
    if (vouchersPending === false || _voucherLogins.success === "") {
      return;
    }

    if (_voucherLogins.success === true) {
      setVoucherLogins(_voucherLogins.data);
      setPagination({ ..._voucherLogins.pagination });
    } else {
      console.log("Failed fetching vouchers!");
    }
    setVouchersPending(false);
    if (!voucherLoginPending && !contingentsPending) {
      setInitialized(true);
    }
    $(window).scrollTop(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_voucherLogins]);

  const loadNextPage = (page) => {
    setVouchersPending(true);

    let requestFilter = { ...filter };
    requestFilter.sort = sort.sort;
    requestFilter.direction = sort.direction;
    requestFilter.limit = paginationLimit;
    requestFilter.page = page;

    // fetch next page
    dispatch(
      voucherTypesActions.getVoucherTypes({
        token: Biscuit.get("token"),
        suffix: "",
        filter: requestFilter,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      })
    );
  };

  const filterChangedHandle = (filter, sorts = null) => {
    let requestFilter = { ...filter };
    if (sorts === null) {
      sorts = sort;
    } else {
      setSort(sorts);
    }
    requestFilter.sort = sorts.sort;
    requestFilter.direction = sorts.direction;
    if (typeof filter.limit !== "undefined") {
      requestFilter.limit = filter.limit;
      if (typeof requestFilter.page !== "undefined") {
        delete requestFilter.page;
      }
    } else {
      requestFilter.limit = paginationLimit;
      requestFilter.page = 1;
    }

    dispatch(
      voucherTypesActions.getVoucherTypes({
        token: Biscuit.get("token"),
        suffix: "",
        filter: requestFilter,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      })
    );
    setVouchersPending(true);
    setFilter(filter);
  };

  const onSortChangedHandle = (ev) => {
    const el = ev.currentTarget;
    const sortKey = el.getAttribute("data-inb-val"),
      direction = el.getAttribute("data-inb-direction"),
      isOppositeElement = direction === null && el.classList.contains("is-active"),
      newDirection = direction === "desc" || isOppositeElement ? "asc" : "desc";

    if (sortKey) {
      let requestFilter;
      if (typeof filter.limit !== "undefined") {
        requestFilter = {
          ...filter,
          sort: sortKey,
          direction: direction,
        };
      } else {
        requestFilter = {
          ...filter,
          sort: sortKey,
          direction: direction,
          limit: paginationLimit,
          page: 1,
        };
      }
      if (in_array(type, ["discount", "gift_card"])) {
        dispatch(
          voucherTypesActions.getVoucherTypes({
            token: Biscuit.get("token"),
            suffix: "",
            filter: requestFilter,
            parameters: {
              headers: {
                "Accept-Language": language,
                "Content-Language": language,
              },
            },
          })
        );
        setVouchersPending(true);
      }
      if (in_array(type, ["vlogin"])) {
        dispatch(
          voucherTypesActions.getVoucherLogins({
            token: Biscuit.get("token"),
            suffix: "",
            parameters: {
              headers: {
                "Accept-Language": language,
                "Content-Language": language,
              },
            },
          })
        );
        setVouchersPending(true);
      }
      setSort({
        sort: sortKey,
        direction: direction,
      });

      const activeSortTab = $(".is-active");
      _.each(activeSortTab, function (key, value) {
        key.classList.remove("is-active");
      });
      el.classList.add("is-active");
      el.setAttribute("data-inb-direction", isOppositeElement ? "desc" : newDirection);
    }
  };

  const searchBarHandler = (ev) => {
    let query;
    if (typeof ev.target !== "undefined") {
      query = ev.target.value.toLowerCase();
    } else {
      query = "";
    }
    searchParams.delete("code");
    if (query !== "") {
      searchParams.set("code", query);
    }
    const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
    history.pushState(null, "", newRelativePathQuery);
    let standardFilter = {
      sort: "name",
      direction: "asc",
      page: 1,
      limit: 40,
      ...allUrlParams,
    };
    const minLength = 1;
    let filterA = standardFilter;
    setResetFilter(true);
    if (query.length >= minLength) {
      // work user search only for values bigger or equal to the minimum length

      setTimeout(function () {
        let diff = Number(moment().format("x")) - _queryState.timeStamp;

        if (diff > 700 && _queryState.value === query) {
          // no changes after the last 700 ms -> user finished input -> start request
          filterChangedHandle({
            ...filterA,
            code: query,
          });
        }
      }, 800);
    } else if (filter.name !== undefined) {
      // reset filter when query was active
      let clone = { ...filter };
      delete clone.name;
      filterChangedHandle(clone);
    } else {
      filterChangedHandle(filterA);
    }
    _queryState.timeStamp = Number(moment().format("x"));
    _queryState.value = query;
  };

  const _exchangeLabel = (value) => {
    let cm = getContentModifications();
    if (cm.labels != null) {
      if (cm.labels[value] !== undefined) {
        return cm.labels[value];
      }
    }
    return value;
  };

  const showNotification = (msgType, itemId, apiMsg = "", type = "vouchers") => {
    // little delay necessary to make notifications visible (render of background must be done before)
    setTimeout(() => {
      if (msgType === "success") {
        new Notification({
          message:
            apiMsg !== "" ? apiMsg : t("saved_${a}", { a: t(type) }, "capital") + " #" + itemId,
          duration: 5000,
          type: "success",
          closeable: true,
          icon: "fi fi-check",
        });
      } else if (msgType === "warning") {
        new Notification({
          message:
            typeof apiMsg !== "undefined" && apiMsg !== null
              ? t(apiMsg, null, "capital")
              : t("request_error", null, "capital"),
          duration: 5000,
          type: "warning",
          closeable: true,
          icon: "fi fi-x",
        });
      }
    }, 200);
  };
  const onRemoveVoucher = (voucher) => {
    if (confirm(t("really_remove"))) {
      dispatch(
        voucherTypesActions.deleteVoucherType({
          id: Number(voucher.id),
          token: Biscuit.get("token"),
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        })
      );
      setVoucherPending(true);
    }
  };

  const onRemoveVoucherLogin = (voucherLogin) => {
    if (confirm(t("really_remove"))) {
      dispatch(
        voucherTypesActions.deleteVoucherLogin({
          id: voucherLogin.user_id,
          token: Biscuit.get("token"),
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        })
      );
      setVoucherLoginPending(true);
    }
  };
  let voucherTypeTabs = [
    {
      name: t("name"),
      mediumWidth: 2,
      smallWidth: 4,
      style: { paddingLeft: "1rem" },
      title: t("sort_by_${a}", { a: t("name") }),
      canSort: true,
      extraClasses: "inb-order-big padding-1",
      sort: {
        direction: "asc",
        data_inb_val: "name",
      },
    },
    {
      name: t("description", null, "capital"),
      mediumWidth: 4,
      smallWidth: 8,
      title: t("description"),
      canSort: false,
      extraClasses: "inb-order-big",
    },
    {
      name: t("voucher_unit", null, "capital"),
      mediumWidth: 1,
      smallWidth: 2,
      style: { marginLeft: "-1rem" },
      extraClasses: "inb-order-big",
      title: t("voucher_unit", null, "capital"),
      canSort: false,
    },
    {
      name: t("voucher_value", null, "capital"),
      mediumWidth: 1,
      smallWidth: 2,
      extraClasses: "inb-order-big",
      title: t("voucher_value", null, "capital"),
      canSort: false,
    },
    {
      name: t("active", null, "capital"),
      mediumWidth: 1,
      smallWidth: 2,
      style: { marginLeft: "-10px" },
      extraClasses: "inb-order-big padding-1",
      title: t("active"),
      canSort: false,
    },
    {
      name: "",
      mediumWidth: 3,
      smallWidth: 3,
      title: t("", null, "capital"),
      canSort: false,
    },
  ];

  let voucherLoginTabs = [
    {
      name: t("name"),
      mediumWidth: 3,
      smallWidth: 6,
      style: { paddingLeft: "1rem" },
      title: t("name"),
      canSort: false,
      extraClasses: "inb-order-big padding-1",
    },
    {
      name: t("voucher_type_valid_to", null, "capital"),
      mediumWidth: 3,
      smallWidth: 6,
      title: t("voucher_type_valid_to"),
      canSort: false,
      extraClasses: "inb-order-big",
    },
    {
      name: t("valid", null, "capital"),
      mediumWidth: 2,
      smallWidth: 4,
      style: { marginLeft: "-1rem" },
      extraClasses: "inb-order-big",
      title: t("valid", null, "capital"),
      canSort: false,
    },
    {
      name: "",
      mediumWidth: 4,
      smallWidth: 8,
      title: t("", null, "capital"),
      canSort: false,
    },
  ];
  const submenuItems = [
    {
      name: t("tab_discount", null, "capital"),
      link: "vouchers?type=discount",
      data_inb_val: t("tab_discount", null, "capital"),
      icon: "fi fi-list-thumbnails",
      isActive: type === "discount",
      isAccessible: isViewVisible("vouchers"),
    },
    {
      name: t("tab_gift_card", null, "capital"),
      link: "vouchers?type=gift_card",
      data_inb_val: t("tab_gift_card", null, "capital"),
      icon: "fi fi-list",
      isActive: type === "gift_card",
      isAccessible: isViewVisible("vouchers"),
    },
    {
      name: t("tab_v_login", null, "capital"),
      link: "vouchers?type=vLogin",
      data_inb_val: t("tab_v_login", null, "capital"),
      icon: "fi fi-list",
      isActive: type === "vlogin",
      isAccessible: isViewVisible("vouchers"),
    },
  ];
  return (
    <>
      <VoucherSidebar
        dispatch={dispatch}
        heading={t("vouchers", null, "capital")}
        filterChangedHandle={filterChangedHandle}
        filter={filter}
        resetFilter={resetFilter}
        setResetFilter={setResetFilter}
        sort={sort}
        setSort={setSort}
        contingents={_contingents.data}
      />
      <div id="inb-c-main" className="columns voucher">
        <InboomaSubmenu
          tabs={submenuItems}
          searchbar={in_array(type, ["discount", "gift_card"])}
          showPagination={in_array(type, ["discount", "gift_card"])}
          searchbarPlaceholder={t("name") + " / " + t("code")}
          extraClasses={"sticky-top"}
          searchbarValue={allUrlParamsClone?.code !== undefined ? allUrlParamsClone.code : ""}
          searchbarHandler={searchBarHandler}
          smallOnlyTitle={t("vouchers", null, "capital")}
          pagination={pagination}
          itemsCountPerPage={paginationLimit}
          pageRangeDisplayed={5}
          onChange={loadNextPage}
          initialized={initialized}
          itemLength={vouchers.length}
        />

        <SortNav
          tabs={in_array(type, ["discount", "gift_card"]) ? voucherTypeTabs : voucherLoginTabs}
          extraClasses={"sticky-top-sortbar"}
          listStyle="tight"
          handler={onSortChangedHandle}
        />
        {/*  {initialized && vouchers.length > 0 && !vouchersPending && typeof pagination !== 'undefined' &&
                    <Paginator
                    pagination={pagination}
                    itemsCountPerPage={paginationLimit}
                    pageRangeDisplayed={5}
                    onChange={loadNextPage}
                    upper={true}
                    />}*/}
        {initialized &&
          vouchers.length > 0 &&
          !vouchersPending &&
          !add &&
          in_array(type, ["discount", "gift_card"]) && (
            <VouchersList
              vouchers={vouchers}
              dispatch={dispatch}
              filterChangedHandle={filterChangedHandle}
              filter={filter}
              onRemoveVoucher={onRemoveVoucher}
              setIndex={setIndex}
              setInitialized={setInitialized}
              showNotification={showNotification}
            />
          )}
        {initialized && voucherLogins.length > 0 && !vouchersPending && type === "vlogin" && (
          <VoucherLoginsList
            voucherLogins={voucherLogins}
            dispatch={dispatch}
            filterChangedHandle={filterChangedHandle}
            filter={filter}
            onRemoveVoucherLogin={onRemoveVoucherLogin}
            setIndex={setIndex}
            setInitialized={setInitialized}
            showNotification={showNotification}
          />
        )}

        {initialized &&
          in_array(type, ["discount", "gift_card"]) &&
          (vouchers.length < 1 || typeof vouchers.length === "undefined") &&
          !vouchersPending && (
            <>
              <div id="inb-app-collection-empty" className="inb-announcement">
                <div className="inb-image-box">
                  <img src="assets/img/no_data.svg" />
                </div>
                <h3>{t("app_msg_collection_empty")}</h3>
                <p>{t("app_msg_collection_empty_body")}</p>
              </div>
            </>
          )}
        {initialized &&
          in_array(type, ["vlogin"]) &&
          (voucherLogins.length < 1 || typeof voucherLogins.length === "undefined") &&
          !vouchersPending && (
            <>
              <div id="inb-app-collection-empty" className="inb-announcement">
                <div className="inb-image-box">
                  <img src="assets/img/no_data.svg" />
                </div>
                <h3>{t("app_msg_collection_empty")}</h3>
                <p>{t("app_msg_collection_empty_body")}</p>
              </div>
            </>
          )}
        {/* {initialized && vouchers.length > 0 && !vouchersPending && typeof pagination !== 'undefined' && in_array(type,['discount','gift_card']) &&
                    <Paginator
                        pagination={pagination}
                        itemsCountPerPage={paginationLimit}
                        pageRangeDisplayed={5}
                        onChange={loadNextPage}
                        upper={false}
                    />}*/}
        {vouchersPending && (
          <>
            {" "}
            <div id="inb-app-collection-empty" className="inb-announcement">
              <div className="inb-image-box">
                <img className="rollingLoader" src="assets/img/rolling_loader.svg" />
              </div>
            </div>
          </>
        )}

        {((params !== null &&
          (!isNaN(params[0]) || params[0] === "add") &&
          initialized &&
          !voucherPending) ||
          index !== null ||
          add !== false) &&
          in_array(type, ["discount", "gift_card"]) && (
            <ItemView
              dispatch={dispatch}
              filterChangedHandle={filterChangedHandle}
              filter={filter}
              showNotification={showNotification}
              requestPath={returnPath}
              voucher={index !== null ? vouchers[index] : voucher}
              setIndex={setIndex}
              setAdd={setAdd}
              setVoucher={setVoucher}
              setVouchersPending={setVouchersPending}
              type={type}
            />
          )}
        {((params !== null &&
          (!isNaN(params[0]) || params[0] === "add") &&
          initialized &&
          !voucherPending) ||
          index !== null ||
          add !== false) &&
          type === "vlogin" && (
            <ItemLoginView
              dispatch={dispatch}
              filterChangedHandle={filterChangedHandle}
              filter={filter}
              showNotification={showNotification}
              requestPath={returnPath}
              voucherLogin={index !== null ? voucherLogins[index] : voucherLogin}
              setIndex={setIndex}
              setAdd={setAdd}
              setVoucherLogin={setVoucherLogin}
              setVouchersPending={setVouchersPending}
            />
          )}
      </div>
    </>
  );
};

export default VouchersView;
